/**
 * this snippet based on:
 * Bootstrap 3 Datepicker v4 — http://eonasdan.github.io/bootstrap-datetimepicker/
 * Moment.js — http://momentjs.com/docs/
 *
 * TODO: move this snippet into BQ-API plugin
 * */
bq.global.dateTimePickerSetup = function () {

    // pre-define moment.js locale and define format
    moment.locale(bq.config.locale);
    var momentDefaultFormat = bq.config.dateFormat;// more info http://momentjs.com/docs/#/displaying/format/

    var dateTimePickerDefaults = {
        allowInputToggle:  true
        , icons:           {
            time:     'fa fa-clock-o',
            date:     'fa fa-calendar',
            up:       'fa fa-arrow-up',
            down:     'fa fa-arrow-down',
            previous: 'fa fa-arrow-left',
            next:     'fa fa-arrow-right',
            today:    'fa fa-crosshairs',
            clear:    'fa fa-trash',
            close:    'fa fa-times'
        }
        , locale:          bq.config.locale
        , format:          momentDefaultFormat
        , showTodayButton: true
        , widgetParent:    'body'

        //, debug: true // Will cause the date picker to stay open after a blur event.
    };

    $(document).trigger("date_time_picker_defaults_available", [dateTimePickerDefaults]);

    // default datetimepickers
    if($('.datetimepicker, .input-daterange input, .datepicker').length) {
      $('.datetimepicker, .input-daterange input, .datepicker').each(function() {
        var $el = $(this);
        if ($el.find('input').length || ($el[0].nodeName === 'INPUT')) {
            $el
              .datetimepicker(dateTimePickerDefaults)
              .on('dp.show', dtpBodyPositionFix);
        }
      });
    }

    $('.date').each(function () {

        var $el     = $(this),
            options = {
                showTodayButton: false
            };

        if (!$el.find('input').length) {
            return;
        }

        var optionKey = '';
        if ($el.attr('data-startDate')) {
            optionKey = 'minDate';
            options[optionKey] = getOptionMarginDate($el, optionKey);
        }

        if ($el.attr('data-endDate')) {
            optionKey = 'maxDate';
            options[optionKey] = getOptionMarginDate($el, optionKey);
        }

        if ($el.find("input").val()) {
            options.defaultDate = moment($el.find("input").val(), momentDefaultFormat);
            options.useCurrent  = false;

            // defaultDate cannot be before minDate
            if (options.minDate > options.defaultDate) {
                options.minDate = options.defaultDate
            }
        }

        if ($el.data('disable-current-date')) {
            options.useCurrent = false;
        }

        // date format update
        if ($el.data('format')) {
            options.format = $el.data('format');
        }

        if (!$el.data('empty')) {
	        delete options.defaultDate;
        }

        if ($el.data('min-date-dependency-name')) {
          if ($('[name="' + $el.data('min-date-dependency-name') + '"]').val() !== '') {
            var minDate = getDependencyMinDate($el);
            options.minDate = minDate;
          }

        }

        $el
            .datetimepicker($.extend(dateTimePickerDefaults, options))
            .on('dp.show', dtpBodyPositionFix)
            .on('dp.change dp.update', function(e) {
                if (!$(this).data('disable-additional-validate')) {
                  parsleyValidate();
                }

                updateDependents(e);
            });
    });

    $('.report-range')
        .datetimepicker(dateTimePickerDefaults)
        .on('dp.show', dtpBodyPositionFix);

    var today       = moment().format(momentDefaultFormat),
        fromDefault = moment().subtract(1, 'months').format(momentDefaultFormat);

    if (!$('#date_range_from').val()) {
        $('#date_range_from').val(fromDefault);
    }
    if (!$('#date_range_to').val()) {
        $('#date_range_to').val(today);
    }
    $('#date_range_from, #date_range_to').each(function (index, element) {
        $(element).parent().data("DateTimePicker").maxDate(moment().endOf('day'));
    });

    function parsleyValidate() {
        var input = $(this).find('input');
        if (input.parsley() && input.val() != "") {
            return input.parsley().validate();
        }
    }

    function getOptionMarginDate(el, optionKey) {

        var elDateValue = '';
        if (optionKey === 'minDate') {
            elDateValue = el.attr('data-startDate');
        } else {
            elDateValue = el.attr('data-endDate');
        }

        var result = false;

        switch (elDateValue) {
            case '-Infinity':
                result = false;
                break;
            case 'now':
            case 'moment':
            case '+0d':
                result = moment(new Date().setHours(0, 0, 0, 0));
                break;
            default:
                var elDate = moment(elDateValue, momentDefaultFormat);
                result = elDate.isValid()
                    ? elDate.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0})
                    : moment(elDateValue);
        }

        return result;
    }

    // in 'body' position fix // https://github.com/Eonasdan/bootstrap-datetimepicker/issues/790#issuecomment-148041302
    function dtpBodyPositionFix(e) {
        var $datepicker = $('body').find('.bootstrap-datetimepicker-widget:last');

        if ($datepicker.hasClass('bottom') || $datepicker.hasClass('top')) {
            var top  = $(this).offset().top + $(this).outerHeight(),
                left = $(this).offset().left,
                distOffScreen = $datepicker.width() - ($(window).width() - left);

            if(($(window).width() - left) < $datepicker.width()) {
                left = left - distOffScreen - 38;
            }

            $datepicker.css({
                'top':    top + 'px',
                'bottom': 'auto',
                'left':   left + 'px'
            });
        }
    }

    function getDependencyMinDate(el) {
        var dependencyName = el.data('min-date-dependency-name');
        var dependencyDate = $('[name="' + dependencyName + '"]').val();

	      return getDateFromString(dependencyDate);
    }

    function updateDependents(e) {
        var targetEl = $(e.target).closest('[data-bq="validate-form"]');

	      $('*[data-min-date-dependency-name]').each(function () {
            var dependencyName = $(this).data('min-date-dependency-name');

            if ($('input[name="' + dependencyName + '"]', targetEl).length > 0) {
                var dependencyEl = $('input[name="' + dependencyName + '"]', targetEl);
	              var minDate = false;

	              if (dependencyEl.val() !== '') {
                  minDate = getDateFromString(dependencyEl.val());
                }

	              $(this).data("DateTimePicker").minDate(minDate);
            }
        });
    }

    function getDateFromString(dateString) {
        var dateObj = moment(dateString, momentDefaultFormat);
        return dateObj.toDate();
    }
};


bq.init.push(bq.global.dateTimePickerSetup);
